
export function getBusinessFormStyle(){
    return{
        formStyle : {
            '.form-check-input' : {
                marginTop: '0.5rem'
            }
        }
    }   
}